import type { AppointmentsFeatures } from './type';

export const appointments: AppointmentsFeatures = {
    branchA11ySearch: {
        enabled: false,
        _description:
            'Enables branch search by a11y options supported by the branch, e.g.: wheelchair, visual, hearing',
    },
};
